import { useParams } from "react-router";

import { SiteGroupEditForm } from "src/app/features/SiteGroup/components/forms/SiteGroupEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { HistoryButton } from "../../../../components/FeatureButtons/HistoryButton";
import { OkButton } from "../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../components/Form/hooks/useFormSubmitTrigger";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";

export const SiteGroupEditFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();
    const hasWriteAccess = canAccess(ResourceName.SITE_GROUPS, "basicTabsWrite");
    const { id } = useParams();
    const dataGroup = getAssignedDataGroup();
    const historyUrl = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/organization-units/${id}/${FORM_ACTION.HISTORY}`;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.SiteGroupsEditFormPage" />
                <ActionBar>
                    <OkButton isDisabled={!hasWriteAccess} onClick={triggerOk} />
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerSubmit} />
                    <HistoryButton url={historyUrl} />
                    <CancelButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.SITE_GROUPS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <SiteGroupEditForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
